export function flattenDnsNameservers(raw: unknown): string[] {
  if (!Array.isArray(raw)) return [];
  return raw
    .map((item) => {
      if (typeof item === 'string') return item;
      if (item && typeof item === 'object' && 'server' in item) {
        return String((item as { server?: string }).server || '');
      }
      return '';
    })
    .filter(Boolean);
}

export function flattenDnsSearches(raw: unknown): string[] {
  if (!Array.isArray(raw)) return [];
  return raw
    .map((item) => {
      if (typeof item === 'string') return item;
      if (item && typeof item === 'object' && 'search' in item) {
        return String((item as { search?: string }).search || '');
      }
      return '';
    })
    .filter(Boolean);
}

export function toFormDnsNameservers(raw: unknown): { server: string }[] {
  return flattenDnsNameservers(raw).map((server) => ({ server }));
}

export function toFormDnsSearches(raw: unknown): { search: string }[] {
  return flattenDnsSearches(raw).map((search) => ({ search }));
}
